import { useState, useEffect } from 'react';
import { TrustedPartner } from '../types';
import { TrustedPartnersService } from '../services/TrustedPartnersService';
import { ApiTrustedPartnersRepository } from '../repository/ApiTrustedPartnersRepository';


export const useTrustedPartners = () => {
  const [partnersByCategory, setPartnersByCategory] = useState<Record<string, TrustedPartner[]>>({});
  const [categories, setCategories] = useState<string[]>([]);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const service = new TrustedPartnersService(new ApiTrustedPartnersRepository());


  useEffect(() => {
    const fetchPartners = async () => {
      try {
        setLoading(true);
        const [groupedPartners, categoryList] = await Promise.all([
          service.getPartnersGroupedByCategory(),
          service.getCategories()
        ]);
        
        setPartnersByCategory(groupedPartners);
        setCategories(categoryList);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load partners');
      } finally {
        setLoading(false);
      }
    };


    fetchPartners();
  }, []);


  return {
    partnersByCategory,
    categories,
    activeCategory,
    setActiveCategory,
    loading,
    error
  };
};


